<template>
    <div class="row">
        <div class="col col-12" style="padding-top:20px;padding-bottom:20px;">
            <div class="form-check form-switch" style="padding-left:0">
                <label class="form-check-label" :for="uid">{{prompt}}: {{BlockProps[propertyname]}}</label>
                <input type="range" class="form-range" :min="min" :max="max" :step="step" v-model="BlockProps[propertyname]">
            </div>

        </div>
        <hr style="margin-top: 10px; margin-bottom:5px;" />
    </div>
</template>

<style>
</style>




<script>
    import { v4 as uuidv4 } from 'uuid';

    export default {
        name: 'propertyrangeeditor',
        emits: [],
        components: { },
        props: [
            "blockprops",
            "propertyname",
            "prompt",
            "min",
            "max",
            "step"
        ],
        data() {
            return {    
                uid: ''
            };
        },
        methods:
        {      
          
        },
        computed:
        {
            BlockProps: function(){
                return this.blockprops;
            }
        },
        beforeMount: function () {

        },
        mounted: function () {
            this.uid = uuidv4();
        },
        beforeUnmount: function () {

        }
    }
</script>
